const Item = {

    // FIELDS
    "category": "Category",
    "sub_category": "Sub Category",
    "brand": "Brand",
    "cost_center": "Cost Center",
    "sold": "Can be Sold",
    "purchased": "Can be Purchased",
    "returned": "Can be Returned",
    "name": "Name",
    "description": "Description",
    "item_code": "Item Code",
    "item_image": "Item Image",
    "group": "Group",
    "primary_unit": "Primary Unit",
    "barcode": "Barcode",
    "status": "Status",
    "tax": "Tax",
    "secondary_unit": "Secondary Unit",
    "weight": "Weight",
    "conversion": "Conversion",
    "color": "Color",
    "segment": "Segment",
    "rack": "Rack",
    "search": "Search",

    // PAGE HEADER
    "item": "Item",

    // SECTION HEADING
    "basic_details": "Basic Details",
    "main_details": "Main Details",
    "other_details": "Other Details",
    "item_details": "Item Details",
    "qr_code": "QR Code",

    // ERROR
    "error_category": "Select Category",
    "error_sub_category": "Select Sub Category",
    "error_brand": "Select Brand",
    "error_cost_center": "Select Cost Center",
    "error_checkbox": "At Least One Option Must be Checked",
    "error_sold": "",
    "error_purchased": "",
    "error_returned": "",
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_item_code": "Enter Item Code",
    "error_item_image": "Choose Item Image",
    "error_group": "Select Group",
    "error_primary_unit": "Select Primary Unit",
    "error_barcode": "Enter Barcode",
    "error_status": "Select Status",
    "error_tax": "Select Tax",
    "error_secondary_unit": "Select Secondary Unit",
    "error_weight": "Enter Weight",
    "error_conversion": "Enter Conversion",
    "error_color": "Select Color",
    "error_segment": "Select Segment",
    "error_rack": "Select Rack",

    // TABLE HEADER
    "table_image": "IMAGE",
    "table_sub_category": "SUB CATEGORY",
    "table_item_code": "ITEM CODE",
    "table_name": 'NAME',
    "table_status": "STATUS",

}

export default Item;